import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup = new FormGroup({});
  email: string = '';
  password: string = '';
  loading = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.loginForm = this.fb.group({
          email: ['', [Validators.required, Validators.email]],
          password: ['', [Validators.required]],
        });
  }

  login() {
    if (this.loginForm.invalid) {
      return;
    }
    this.loading = true;
    const { email, password } = this.loginForm.value;
    // Ensure login returns a Promise
    const loginResult = this.authService.login(email, password);
    if (loginResult && typeof loginResult.then === 'function') {
      loginResult.then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    } else {
      // If not a promise, fallback
      this.loading = false;
    }
  }
}